import React from 'react';
import { Button, Toolbar, useNotify, useRedirect, useTranslate } from 'react-admin';

import useUpdatePartial from 'components/_extensions/react-admin/core/dataProvider/useUpdatePartial';
import { BackButton } from './BackButton';
import { OrderState } from 'entities/OrderState';
import { CircularProgress } from '@material-ui/core';

const ApproveExternalOrderButton = ({ basePath, resource, record }) => {
	const translate = useTranslate();
	const redirect = useRedirect();
	const notify = useNotify();

	const [update, { loading }] = useUpdatePartial(
		resource,
		record.id,
		{state: OrderState.is_external_approved},
		{state: record.state},
		{
			withDeclarativeSideEffectsSupport: true,
			onSuccess: () => {
				redirect("list", basePath)
				notify("osfc.dialogs.confirm_approve_external_order" + ".success", "info");
			},
			onFailure: (error) => {
				notify(error.message, "error");
			}
		},
		'updatePartial'
	);

	const label = translate('resources.external-not-approved-draft-orders.bulk-approve.button');

	return (
		<Button 
			onClick={update} 
			label={label} 
			variant='contained' 
			size='medium'
			disabled={loading}
			startIcon={
				loading ?
					<CircularProgress size={16} thickness={5} color="inherit" />
					: undefined
			}
		/>
	);
};

export const ApproveExternalWithCancelToolbar = ({ children, ...props }) => (
	<Toolbar {...props} >
		<ApproveExternalOrderButton />
		<BackButton />
		{children}
	</Toolbar>
);
